import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import { Result, Button } from "antd";

const AdminRoute = ({ children }: { children: JSX.Element }) => {
  const userData = useSelector((state: any) => state.authentication.userData);

  // Check if user is admin or superadmin
  if (userData?.role !== 'admin' && userData?.role !== 'superadmin') {
    return (
      <PrivateRoute>
        <div style={{ padding: '50px', textAlign: 'center' }}>
          <Result
            status="403"
            title="403"
            subTitle="Уучлаарай, энэ хуудас руу нэвтрэх эрхгүй байна. Зөвхөн админ хэрэглэгчид нэвтрэх боломжтой."
            extra={
              <Button type="primary" href="/">
                Нүүр хуудас руу буцах
              </Button>
            }
          />
        </div>
      </PrivateRoute>
    );
  }

  return <PrivateRoute>{children}</PrivateRoute>;
};

export default AdminRoute;
